import Vue from 'vue'

export default el => new Vue({
  el,
  data () {
    return {
      id: el.dataset.id
    }
  },
  mounted () {
    this.$el.style.maxHeight = this.getHeight()
    window.addEventListener('resize', () => {
      if (this.isFAQOpen()) {
        this.$el.style.maxHeight = this.getHeight()
      } else {
        if (window.innerWidth < 768) {
          if (this.$el.style.maxHeight === '4em') {
            this.$el.style.maxHeight = '3em'
          }
        } else if (this.$el.style.maxHeight === '3em') {
          this.$el.style.maxHeight = '4em'
        }
      }
    })
  },
  methods: {
    getHeight () {
      return this.$el.scrollHeight + 'px'
    },
    isFAQOpen () {
      return this.$refs.collapseButton.classList.contains('faq-list__collapse-button--open')
    },
    toggleFAQAccordion () {
      this.$refs.collapseButton.classList.toggle('faq-list__collapse-button--open')
    },
    toggleFAQGroup () {
      if (this.isFAQOpen()) {
        this.$el.style.maxHeight = window.innerWidth < 768 ? '3em' : '4em'
        this.$el.style.overflow = 'hidden'
      } else {
        this.$el.style.maxHeight = this.getHeight()
        this.$el.style.overflow = 'visible'
      }
      this.toggleFAQAccordion()
    }
  }
})
